import React from "react";
export const AppContext = React.createContext({
  authenticated: false, // to check if authenticated or not
  user: { role: "", companyId: "" }, // store all the user details
  accessRules: new Array<any>(),
  initiateLogin: (values: any, loginType: any, dashboardUser: any) => { }, // to start the login process
  handleAuthentication: (loginResp: any) => { }, // handle Auth0 login process
  logout: () => { }, // logout the user
});
export const AuthProvider = AppContext.Provider;
export const AuthConsumer = AppContext.Consumer;
